import { CHART_BASE_DATA, CHART_CONFIG } from '../constants';
import { IChartPoint } from '../types';

export const buildChartData = (limitValue: number): IChartPoint[] => {
  const increaseDelta = (limitValue / 100) * CHART_CONFIG.increasePer100Limit;

  return CHART_BASE_DATA.map(point => {
    const baseIncrease = point.baseIncrease;
    const increase = baseIncrease != null ? baseIncrease + increaseDelta : undefined;

    return {
      name: point.name,
      default: point.default,
      ...(increase != null && { increase }),
    };
  });
};
